<template>    
  <div v-if="!device?.isVirtual" class="list-group card-item" style="border-radius: 1.2rem; margin-top: 1px;" v-touch:press="onTouchDown" v-touch:drag="onTouchDrag" v-touch:release="onTouchRelease" v-touch:hold="onTouchHold">
    <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; padding: 2px 0px; background-color: #ffecb3`">
      <img
        :src="require('@/assets/images/curtain.svg')"
        style="margin-right: 0.4rem; height: 13px; width: 13px; margin-top: -2px;" class="ms-3 me-2" />
      <div class="flex-fill" style="font-size: 0.8rem">
        {{ device.name }}
        <br>
        {{ currentStateText }}
      </div>
      <div class="mx-0 h-100" style="border-radius: 10px 0px 0px 10px; border: 1px solid #ffd082; border-right: 0px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsOpen)">
        <div style="margin-top: 21px; width:40px; text-align: center;">열기</div>
      </div>
      <div class="mx-0 h-100" style="border: 1px solid #ffd082; border-right: 0px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsStop)" >
        <div style="margin-top: 21px; width:40px; text-align: center;">멈춤</div>
      </div>
      <div class="mx-0 h-100" style="border-radius: 0px 10px 10px 0px; border: 1px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsClose)">
        <div style="margin-top: 21px; width:40px; text-align: center;">닫기</div>
      </div>
      <div class="mx-0 h-100" @click.stop="onSettingClicked" style="border-radius: 0rem 1.2rem 1.2rem 0rem;">
        <i class="fa-solid fa-gear" style="font-size: 0.8rem; margin-top: 24px; width: 40px; text-align: center;" />
      </div>
    </div>
  </div>

  <div v-else class="list-group" style="border-radius: 1.2rem; margin-top: 1px;" v-touch:press="onTouchDown" v-touch:drag="onTouchDrag" v-touch:release="onTouchRelease" v-touch:hold="onTouchHold">
    <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; padding: 2px 0px; background-color: #ffecb3`">
      <img
        :src="require('@/assets/images/curtain.svg')"
        style="margin-right: 0.4rem; height: 13px; width: 13px; margin-top: -2px;" class="ms-3 me-2" />
      <div class="flex-fill" style="font-size: 0.8rem">
        {{ device.name }} (가상버튼)
        <br>
        {{ currentStateText }}
      </div>
      <div class="mx-0 h-100" style="border-radius: 10px 0px 0px 10px; border: 1px solid #ffd082; border-right: 0px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsOpen)">
        <div style="margin-top: 21px; width:40px; text-align: center;">열기</div>
      </div>
      <div class="mx-0 h-100" style="border: 1px solid #ffd082; border-right: 0px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsStop)" >
        <div style="margin-top: 21px; width:40px; text-align: center;">멈춤</div>
      </div>
      <div class="mx-0 h-100" style="border-radius: 0px 10px 10px 0px; border: 1px solid #ffd082; background-color: #ffe082;" @click.stop="onCurtainDevicePowerClicked(MQTTCurtainCommand.IsClose)">
        <div style="margin-top: 21px; width:40px; text-align: center;">닫기</div>
      </div>
      <div class="mx-0 h-100" @click.stop="onSettingClicked" style="border-radius: 0rem 1.2rem 1.2rem 0rem;">
        <i class="fa-solid fa-gear" style="font-size: 0.8rem; margin-top: 24px; width: 40px; text-align: center;" />
      </div>
    </div>
  </div>
        
  <!-- v-if 금지: 물리버튼 할당 대기 중 모달 닫아도 컴포넌트·watch/타이머 유지 -->
  <CurtainDeviceItemModal
    :visible="curtainDeviceItemModal.visible"
    :cancelCallback="curtainDeviceItemModal.hide"
    :roomName="props.roomName"
    :roomId="props.roomId"
    :deviceId="props.deviceId"
    :index="props.index"
    :handlePowerClick="onCurtainDevicePowerClicked"
  />
</template>

<script setup>
import { reactive, defineProps, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import { ButtonConfig, PowerState, MQTTCurtainCommand, MQTTDooyaRonoCommand, getDooyaRonoCtrlData } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import useDeviceTouch from '@/common/hooks/useDeviceTouch';
import useModal from '@/common/hooks/useModal';
import CurtainDeviceItemModal from './CurtainDeviceItemModal.vue';
import Axios, { DeviceApi } from '@/api';
import {
  syncCurtainLinkedLights,
  linkedLightsTurnOnForCurtainCommand,
} from '@/common/utils/curtainLinkedLights';

const mqttControl = reactive(useMqttControl());
const props = defineProps(['roomId', 'roomName', 'deviceId', 'index']);
const store = useStore();
const curtainDeviceItemModal = reactive(useModal());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const { 
  handlePower, 
  handleTouchDown, 
  handleTouchDrag, 
  handleTouchRelease, 
  handleTouchHold 
} = useDeviceTouch(props.roomId);

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});
const device = computed(() => {
  return devices.value.find(
    (d) => d._id === props.deviceId,
  );
});

const getPower = computed(() => {
  return device.value.item.close == PowerState.On;
});

const currentStateText = computed(() => {
  return '';
  return getPower.value ? "닫힘" : "열림";
})

const requestUpdateDevice = async (id, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(DeviceApi.UPDATE_DEVICE.replace(':id', id), params);
      if (result.resultCode === '0000') {
        store.commit('home/updateDevice', {
          groupId: group.value._id,
          id,
          data: params,
        });
        resolve(result);
      } else {
        emitter.emit('showPopAlert', {
          description: result.resultMessage,
        });
        reject(result.resultMessage);
      }
    } catch (error) {
      emitter.emit('showPopAlert', {
        description: '장치 정보 수정에 실패했습니다.',
      });
      reject('장치 정보 수정에 실패했습니다.');
    }
  });
};

const onCurtainDevicePowerClicked = (command) => {
  handlePower(async () => {
    try {
      if (!command) {
        return;
      }
      emitter.emit('showLoading');
      try {
        if (device.value.type == 3) {
          mqttControl.onPublishTemp(device.value.controllerId, command, `${device.value.item.address}`);
        } else if (device.value.type == 5) {
          mqttControl.onPublish(device.value.controllerId, device.value._id, {
            cmd: MQTTDooyaRonoCommand.DooyaCtrl,
            type: 1,
            data: getDooyaRonoCtrlData(device.value.item, command),
          });
        } else if (device.value.type == 6) {
          mqttControl.onPublish(device.value.controllerId, device.value._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: getDooyaRonoCtrlData(device.value.item, command),
          });
        }
        await requestUpdateDevice(device.value._id, {
          item: { close: getPower.value ? 0 : 1 }
        });
        const linkedTurnOn = linkedLightsTurnOnForCurtainCommand(command);
        if (linkedTurnOn != null) {
          await syncCurtainLinkedLights({
            mqttControl,
            store,
            curtainId: device.value._id,
            turnOn: linkedTurnOn,
          });
        }
        setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
      } catch (error) {
        emitter.emit('hideLoading');
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  });
};

const onCurtainDeviceInfoClicked = (e) => {
  curtainDeviceItemModal.show();
};

const onSettingClicked = (e) => {
  onCurtainDeviceInfoClicked();
}

const onTouchHold = (e) => {
  handleTouchHold(e, onSettingClicked);
}
</script>

<style scoped>
.card-item {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.card-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}
</style>
